import {BasePqmFieldValue} from "./BasePqmFieldValue";
import {PqmFieldRegister} from "./PqmFieldRegister";
import {getSelectedValue, setSelectedValue} from "../../Utils";
import {PqmPacket, PqmProcData} from "../pqmTypes";
import {UiRadioList} from "../../components/UiRadioList";
import {TreeSelector} from "../../TreeSelector";

export class PqmFieldEnum extends BasePqmFieldValue {
	static getValueTypes(): string[] {
		return [ "enum:*" ];
	}

	beforeIndex() {
		// @ts-ignore
		this.muAppendContent({
			radioList: `<div mu="value:UiRadioList#value" class="radiolist-vertical"></div>`,
			radioListHorizontal: `<div mu="value:UiRadioList#value" class="radiolist-horizontal"></div>`,
			radioTree: `<div mu="value:TreeSelector#value" mu-params='{"inModal":true}'></div>`,
			select: `<select mu="value#value;numberingValues:@options" class="form-control"></select>`,
		}[this.control]);
	}

	afterIndex() {
		if (this.numberingId) {
			const numberingValues = (this.getPropertyInAncestors('pqmProcData') as PqmProcData).numberingValues[this.numberingId];
			switch (this.control) {
				case 'radioList':
				case 'radioListHorizontal':
					(this.muNamedWidget.value as unknown as UiRadioList).bindItems(
						numberingValues.map(nv => ({ id: nv.id.toString(), title: nv.name }))
					);
					break;
				case 'select':
					this.muBindData({
						numberingValues: [ { value: "", text: "-" }, ...numberingValues.map(nv => ({ value: nv.id, text: nv.name })) ]
					});
					break;
				case 'radioTree':
					(this.muNamedWidget.value as unknown as TreeSelector).bindTree(
						numberingValues.map(nv => ({ id: nv.id.toString(), title: nv.name, parentId: nv.parentId?.toString() || null }))
					);
					break;
			}
		}
	}

	setDisabled(disabled: boolean) {
		if (this.muNamedWidget.value) {
			this.muNamedWidget.value.setDisabled(disabled);
		} else this.ui.value.disabled = disabled;
	}
}

PqmFieldRegister.register(PqmFieldEnum);